/* product-hero-custom.js */
(function () {
  'use strict';


  /* WH-172: bounded/retrying fetch with plain-fetch fallback; cart POSTs are
     duplicate-safe via cartMutate. */
  var ehFetch = function (url, opts) {
    return window.EH && window.EH.fetchRetry ? window.EH.fetchRetry(url, opts) : fetch(url, opts);
  };
  var ehCartPost = function (url, payload) {
    return window.EH && window.EH.cartMutate
      ? window.EH.cartMutate(url, payload)
      : fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload),
        });
  };

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return '₹' + amount.toLocaleString('en-IN');
  }

  function initProductHero(sectionId) {
    var section   = document.getElementById('phc-' + sectionId);
    var sticky    = document.getElementById('phc-sticky-' + sectionId);
    var cartEl    = document.getElementById('phc-cart-' + sectionId);
    var atcBtn    = document.getElementById('phc-atc-' + sectionId);
    var buyBtn    = document.getElementById('phc-buy-' + sectionId);
    var stickyCart = document.getElementById('phc-sticky-cart-' + sectionId);
    var stickyBuy  = document.getElementById('phc-sticky-buy-' + sectionId);
    var qtyEl     = document.getElementById('phc-qty-' + sectionId);
    var mainImg   = document.getElementById('phc-main-img-' + sectionId);
    var curEl     = document.getElementById('phc-cur-' + sectionId);
    var cmpEl     = document.getElementById('phc-cmp-' + sectionId);
    var discEl    = document.getElementById('phc-disc-' + sectionId);
    var scrollThumb = document.getElementById('phc-thumb-' + sectionId);
    var packCards = document.getElementById('phc-packs-' + sectionId);
    var descEl    = document.getElementById('phc-desc-' + sectionId);

    if (!section || !cartEl) return;

    /* ── Thumbnail arrows ── */
    var thumbsEl  = document.getElementById('phc-thumbs-' + sectionId);
    var prevArrow = section.querySelector('.phc-thumbs-arrow--prev');
    var nextArrow = section.querySelector('.phc-thumbs-arrow--next');

    if (thumbsEl && (prevArrow || nextArrow)) {
      var isDesktop = window.innerWidth >= 700;

      function scrollThumbs(dir) {
        var amount = isDesktop
          ? thumbsEl.querySelector('.phc-thumb').offsetHeight + 12
          : thumbsEl.querySelector('.phc-thumb').offsetWidth + 12;
        if (isDesktop) {
          thumbsEl.scrollBy({ top: dir * amount * 3, behavior: 'smooth' });
        } else {
          thumbsEl.scrollBy({ left: dir * amount * 3, behavior: 'smooth' });
        }
      }

      function updateArrows() {
        isDesktop = window.innerWidth >= 700;
        if (prevArrow) prevArrow.disabled = isDesktop ? thumbsEl.scrollTop <= 0 : thumbsEl.scrollLeft <= 0;
        if (nextArrow) {
          var atEnd = isDesktop
            ? thumbsEl.scrollTop + thumbsEl.clientHeight >= thumbsEl.scrollHeight - 2
            : thumbsEl.scrollLeft + thumbsEl.clientWidth >= thumbsEl.scrollWidth - 2;
          nextArrow.disabled = atEnd;
        }
      }

      if (prevArrow) prevArrow.addEventListener('click', function () { scrollThumbs(-1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { scrollThumbs(1); });
      thumbsEl.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    }

    /* ── Gallery ── */
    section.querySelectorAll('.phc-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        if (!src || !mainImg) return;

        section.querySelectorAll('.phc-thumb').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        mainImg.classList.add('is-transitioning');
        setTimeout(function () {
          // WH-96: clear the responsive srcset so the clicked thumbnail's src is honoured
          // (srcset, set for the initial LCP load, otherwise wins over src).
          mainImg.srcset = '';
          mainImg.src = src;
          mainImg.classList.remove('is-transitioning');
        }, 150);
      });
    });

    /* ── Mobile image carousel progress bar (slide) ── */
    var carouselEl = document.getElementById('phc-carousel-' + sectionId);
    var progFill   = document.getElementById('phc-progress-' + sectionId);
    if (carouselEl && progFill) {
      var slideCount = carouselEl.children.length || 1;
      progFill.style.width = (100 / slideCount) + '%';
      carouselEl.addEventListener('scroll', function () {
        var max = carouselEl.scrollWidth - carouselEl.clientWidth;
        var p = max > 0 ? carouselEl.scrollLeft / max : 0;
        progFill.style.transform = 'translateX(' + (p * (slideCount - 1) * 100) + '%)';
      }, { passive: true });
    }

    /* ── Price display helper (price × qty) ── */
    function getQty() {
      return parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
    }

    function updatePriceDisplay() {
      var price   = parseInt(cartEl.dataset.price, 10) || 0;
      var compare = parseInt(cartEl.dataset.comparePrice, 10) || 0;
      var qty     = getQty();

      // WH: the title price (curEl/cmpEl/discEl) is frozen at the Pack-of-1 price
      // rendered by Liquid and must NOT track the selected pack or quantity.
      // Only the Buy Now button reflects the selected pack × quantity.
      if (buyBtn) buyBtn.textContent = 'BUY NOW AT ' + formatMoney(price * qty);
    }

    /* ── Pack card selection → update price row ── */
    if (packCards) {
      packCards.querySelectorAll('.phc-pack-card__radio').forEach(function (radio) {
        radio.addEventListener('change', function () {
          var card = radio.closest('.phc-pack-card');
          if (!card) return;

          cartEl.dataset.variantId   = card.dataset.variantId;
          cartEl.dataset.price       = card.dataset.price;
          cartEl.dataset.comparePrice = card.dataset.comparePrice || '0';

          updatePriceDisplay();
        });
      });
    }

    /* ── Qty stepper ── */
    section.querySelectorAll('.phc-qty__btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyEl) return;
        var current = getQty();
        if (btn.dataset.action === 'plus') {
          qtyEl.textContent = current + 1;
        } else if (btn.dataset.action === 'minus' && current > 1) {
          qtyEl.textContent = current - 1;
        }
        updatePriceDisplay();
      });
    });

    /* ── Cart drawer helper (matches Prestige extractSectionId) ── */
    function getDrawerSectionId() {
      var el = document.querySelector('cart-drawer');
      if (!el) return null;
      var section = el.closest('.shopify-section');
      return section ? section.id.replace('shopify-section-', '') : null;
    }

    /* ── WH-247: loading state + re-entry guard ──
       One in-flight flag per section instance: a second tap on any ATC/Buy Now
       button is ignored until the current request settles, so no duplicate
       add_to_cart. setLoading toggles the inline spinner (.is-loading, styled
       in product-hero-custom.css) on a pair of buttons; endAction clears the
       guard and restores every button. */
    var inFlight = false;
    var atcButtons = [atcBtn, stickyCart].filter(Boolean);
    var buyButtons = [buyBtn, stickyBuy].filter(Boolean);
    function setLoading(buttons, on) {
      buttons.forEach(function (b) { b.classList.toggle('is-loading', on); });
    }
    function endAction() {
      inFlight = false;
      setLoading(atcButtons, false);
      setLoading(buyButtons, false);
    }

    /* ── Add to Cart ──
       The caller (click handler, or the Buy Now fallback) sets the in-flight
       guard + spinner before calling; addToCart clears them on completion. */
    function addToCart(callback) {
      var variantId = parseInt(cartEl.dataset.variantId, 10);
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;

      if (!variantId) { endAction(); return; }

      var sectionId = getDrawerSectionId();
      var body = { id: variantId, quantity: qty };
      if (sectionId) body.sections = sectionId;

      ehCartPost('/cart/add.js', body)
        .then(function (r) { return r.json(); })
        .then(function (addResp) {
          return ehFetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              if (addResp.sections) cart.sections = addResp.sections;
              return cart;
            });
        })
        .then(function (cart) {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cart }
          }));
          /* ── Analytics ── */
          var priceInRupees = (parseInt(cartEl.dataset.price, 10) || 0) / 100;
          var productTitle = (document.querySelector('.phc-title') || {}).textContent || '';
          if (window.fireAddToCartEvent) window.fireAddToCartEvent(String(variantId), productTitle.trim(), priceInRupees, qty);
          /* Buy Now (callback = goCheckout) navigates away — keep the spinner
             visible through the redirect. Plain Add to Cart restores the button
             as the cart drawer opens (the drawer is the success confirmation). */
          if (typeof callback === 'function') callback();
          else endAction();
        })
        .catch(function (err) {
          endAction();
          console.error('[Product Hero] Cart error:', err);
        });
    }

    /* ── Sticky-bar engagement events (EVERHOPE-520) ──
       Mobile PDP sticky bar has its own ADD TO CART / BUY NOW buttons; both
       call addToCart() and so fire the generic add_to_cart, with no way to
       tell sticky-bar taps from the main-page buttons. Push a dedicated
       dataLayer event before addToCart() so GTM can measure sticky engagement. */
    function pushStickyEvent(eventName) {
      var priceInRupees = (parseInt(cartEl.dataset.price, 10) || 0) / 100;
      var productTitle = ((document.querySelector('.phc-title') || {}).textContent || '').trim();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: eventName,
        product_title: productTitle,
        product_handle: cartEl.dataset.handle || '',
        variant_id: cartEl.dataset.variantId || '',
        price: priceInRupees
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (inFlight) return;
        inFlight = true;
        setLoading(atcButtons, true);
        addToCart();
      });
    }

    if (stickyCart) {
      stickyCart.addEventListener('click', function () {
        if (inFlight) return;
        inFlight = true;
        pushStickyEvent('sticky_add_to_cart');
        setLoading(atcButtons, true);
        addToCart();
      });
    }

    /* Facebook in-app browser blocks window.location navigation triggered
       from inside fetch().then() because the user gesture is already consumed.
       window.open with _top replaces the current top frame and is not blocked. */
    function navigateTo(url) {
      if (/FBAN|FBAV|FB_IAB|Instagram/.test(navigator.userAgent)) {
        window.open(url, '_top');
        return;
      }
      window.location.href = url;
    }

    function goCheckout() {
      var url = '/checkout';
      var go = function () { navigateTo(url); };
      var mp = window.everhopeMarketingParams;
      if (!(mp && typeof mp.sync === 'function')) return go();
      var navigated = false;
      var once = function () { if (!navigated) { navigated = true; go(); } };
      Promise.resolve(mp.sync()).catch(function () {}).then(once);
      setTimeout(once, 1200); // best-effort: never hold checkout hostage to the write
    }

    /* ── WH-243: Express Buy Now ──
       Buy Now must check out ONLY the tapped variant × qty. The shared Ajax
       cart is synced across sessions/devices for logged-in customers, so the
       legacy add-to-cart → /checkout flow pulls other sessions' items into the
       checkout. Instead, create a one-off Storefront API cart (its own token,
       never touches the browser cart) and navigate to its checkoutUrl.
       Attribution rides as cart attributes (same map the Ajax cart gets);
       COD gating is evaluated at checkout from the delivery address, so it
       applies to this cart like any other. Any failure — flag off, token
       missing, timeout, userErrors, empty lines — falls back silently to the
       legacy flow: Buy Now can never break. */
    function buyNowExpress() {
      var fallback = function () { addToCart(goCheckout); };
      try {
        var settings = (window.themeVariables && window.themeVariables.settings) || {};
        var token = settings.storefrontApiToken;
        if (settings.enableExpressBuyNow !== true || !token) return fallback();

        var variantId = parseInt(cartEl.dataset.variantId, 10);
        var qty = getQty();
        if (!variantId) { endAction(); return; } // clear the guard/spinner on no-op

        var attributes = [];
        try {
          var mp = window.everhopeMarketingParams;
          var map = (mp && typeof mp.readCart === 'function') ? mp.readCart() : {};
          Object.keys(map).forEach(function (key) {
            attributes.push({ key: key, value: String(map[key]) });
          });
        } catch (_) { /* attribution is best-effort, never blocks checkout */ }

        var input = {
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: qty }],
          attributes: attributes
        };
        if (settings.customerEmail) input.buyerIdentity = { email: settings.customerEmail };

        var query = 'mutation cartCreate($input: CartInput!) { cartCreate(input: $input) {' +
          ' cart { checkoutUrl lines(first: 1) { edges { node { quantity } } } }' +
          ' userErrors { message } } }';

        var request = ehFetch('/api/2025-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Shopify-Storefront-Access-Token': token
          },
          body: JSON.stringify({ query: query, variables: { input: input } })
        }).then(function (r) { return r.json(); });

        var timeout = new Promise(function (_, reject) {
          setTimeout(function () { reject(new Error('express buy now timeout')); }, 4000);
        });

        Promise.race([request, timeout])
          .then(function (resp) {
            var result = resp && resp.data && resp.data.cartCreate;
            var cart = result && result.cart;
            var hasLines = !!(cart && cart.lines && cart.lines.edges && cart.lines.edges.length);
            if (!cart || !cart.checkoutUrl || !hasLines || (result.userErrors && result.userErrors.length)) {
              throw new Error('express buy now: invalid cart response');
            }
            /* Analytics parity: the legacy path fires add_to_cart after
               /cart/add.js succeeds — fire the same event here so funnels
               don't shift. The fallback path fires it inside addToCart(),
               so each Buy Now emits exactly one add_to_cart either way. */
            var priceInRupees = (parseInt(cartEl.dataset.price, 10) || 0) / 100;
            var productTitle = ((document.querySelector('.phc-title') || {}).textContent || '').trim();
            if (window.fireAddToCartEvent) window.fireAddToCartEvent(String(variantId), productTitle, priceInRupees, qty);
            navigateTo(cart.checkoutUrl);
          })
          .catch(function () { fallback(); });
      } catch (_) {
        fallback();
      }
    }

    if (stickyBuy) {
      stickyBuy.addEventListener('click', function () {
        if (inFlight) return;
        inFlight = true;
        pushStickyEvent('sticky_buy_now');
        setLoading(buyButtons, true);
        buyNowExpress();
      });
    }

    /* ── Buy Now ── */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (inFlight) return;
        inFlight = true;
        setLoading(buyButtons, true);
        buyNowExpress();
      });
    }

    /* WH-247: on bfcache restore (Back from checkout after a Buy Now, or from
       the cart) clear any leftover spinner/guard so no button is stuck. */
    window.addEventListener('pageshow', endAction);

    /* ── Pack cards scrollbar thumb (desktop) ── */
    if (packCards && scrollThumb) {
      var scrollbarTrack = scrollThumb.parentElement;

      function updateScrollThumb() {
        var scrollLeft  = packCards.scrollLeft;
        var scrollWidth = packCards.scrollWidth;
        var clientWidth = packCards.clientWidth;
        var maxScroll   = scrollWidth - clientWidth;
        if (maxScroll <= 1) {
          if (scrollbarTrack) scrollbarTrack.style.display = 'none';
          return;
        }
        if (scrollbarTrack) scrollbarTrack.style.display = 'block';
        var thumbW = clientWidth / scrollWidth;
        var thumbL = scrollLeft / scrollWidth;
        scrollThumb.style.width = (thumbW * 100) + '%';
        scrollThumb.style.left  = (thumbL * 100) + '%';
      }

      packCards.addEventListener('scroll', updateScrollThumb, { passive: true });
      window.addEventListener('resize', updateScrollThumb, { passive: true });
      updateScrollThumb();
    }

    /* ── Description "See More" ── */
    section.querySelectorAll('.phc-see-more').forEach(function (btn) {
      var targetId = btn.dataset.target;
      var target   = document.getElementById(targetId);
      if (!target) return;

      /* toggle: expand ⇄ collapse (See More ⇄ " See Less") */
      btn.addEventListener('click', function () {
        try {
          var expanded = target.classList.toggle('is-expanded');
          target.style.maxHeight = expanded ? target.scrollHeight + 'px' : '';
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          btn.textContent = expanded ? ' See Less' : 'See More';
        } catch (e) {
          /* fail silently — never crash the storefront */
        }
      });
    });



    /* ── Delivery check (basic pincode validation) ── */
    var checkBtn = section.querySelector('.phc-delivery__check-btn');
    var resultEl = document.getElementById('phc-delivery-result-' + sectionId);
    var pincodeInput = document.getElementById('phc-pincode-' + sectionId);

    if (checkBtn && pincodeInput) {
      checkBtn.addEventListener('click', function () {
        var val = pincodeInput.value.trim();
        if (!resultEl) return;

        if (!/^\d{6}$/.test(val)) {
          resultEl.textContent = 'Please enter a valid 6-digit pincode.';
          resultEl.className = 'phc-delivery__result is-error';
          return;
        }
        resultEl.textContent = 'Checking delivery availability…';
        resultEl.className = 'phc-delivery__result';

        /* Placeholder — replace with real API call if available */
        setTimeout(function () {
          resultEl.textContent = 'Delivery available to ' + val + ' in 3–5 business days.';
          resultEl.className = 'phc-delivery__result is-success';
        }, 600);
      });

      pincodeInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') checkBtn.click();
      });
    }

    /* ── Ask Expert — append input text to WhatsApp URL ── */
    var expertInput = document.getElementById('phc-expert-input-' + sectionId);
    var expertBtn   = document.getElementById('phc-expert-btn-' + sectionId);

    if (expertInput && expertBtn) {
      var baseUrl = expertBtn.dataset.baseUrl || expertBtn.getAttribute('href') || '';

      expertBtn.addEventListener('click', function (e) {
        var question = expertInput.value.trim();
        if (!question || !baseUrl || baseUrl === '#') return;

        e.preventDefault();
        var url = baseUrl;
        if (url.indexOf('wa.me') !== -1 || url.indexOf('whatsapp.com') !== -1) {
          var sep = url.indexOf('?') === -1 ? '?' : '&';
          url = url + sep + 'text=' + encodeURIComponent(question);
        }
        window.open(url, '_blank', 'noopener,noreferrer');
      });
    }
  }

  /* ── view_item event on page load ── */
  function fireViewItemEvent() {
    var cartEl = document.querySelector('[id^="phc-cart-"]');
    if (!cartEl) return;
    var variantId = cartEl.dataset.variantId || '';
    var price = (parseInt(cartEl.dataset.price, 10) || 0) / 100;
    var title = ((document.querySelector('.phc-title') || {}).textContent || '').trim();
    if (window.gtag) {
      gtag('event', 'view_item', { currency: 'INR', value: price, items: [{ item_id: String(variantId), item_name: title, price: price, quantity: 1 }] });
    }
    if (window.fbq) {
      fbq('track', 'ViewContent', { content_ids: [String(variantId)], content_type: 'product', value: price, currency: 'INR' });
    }
  }

  /* ── Boot on DOMContentLoaded ── */
  function boot() {
    document.querySelectorAll('.phc-section[data-section-id]').forEach(function (el) {
      initProductHero(el.dataset.sectionId);
    });
    fireViewItemEvent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) initProductHero(id);
  });
})();

/* WH (staging): tap PDP gallery image -> fullscreen SWIPEABLE lightbox (left/right) with close X */
(function () {
  function initLightbox() {
    var imgs = [].slice.call(document.querySelectorAll('.phc-carousel .phc-slide-img'));
    if (!imgs.length) return;
    var overlay = document.getElementById('phc-lightbox');
    if (overlay) return; // already built
    overlay = document.createElement('div');
    overlay.id = 'phc-lightbox';
    overlay.className = 'phc-lightbox';
    var track = document.createElement('div');
    track.className = 'phc-lightbox__track';
    var bigs = [];
    imgs.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'phc-lightbox__slide';
      var big = document.createElement('img');
      big.className = 'phc-lightbox__img';
      big.decoding = 'async';
      // WH-254: show the slide's already-loaded (cached) image instantly — zero extra page-load bytes
      // (this is the URL the carousel already fetched). The crisp high-res zoom image is fetched on
      // demand in loadHiRes(), never at page load: initLightbox() builds this overlay at page load, so
      // an eager high-res src here would download every 1400w image up front (defeating the ticket).
      big.src = img.currentSrc || img.src;
      big._zoomSrc = img.dataset.zoomSrc || '';
      bigs.push(big);
      slide.appendChild(big);
      track.appendChild(slide);
    });
    var close = document.createElement('button');
    close.className = 'phc-lightbox__close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '&times;';

    /* prev / next arrows (chevrons, theme-style; coloured light-pink via CSS) */
    var CHEVRON = function (pts) { return '<svg viewBox="0 0 24 24" width="29" height="29" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + pts + '"/></svg>'; };
    var prev = document.createElement('button');
    prev.className = 'phc-lightbox__nav phc-lightbox__nav--prev';
    prev.type = 'button'; prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = CHEVRON('15 18 9 12 15 6');
    var next = document.createElement('button');
    next.className = 'phc-lightbox__nav phc-lightbox__nav--next';
    next.type = 'button'; next.setAttribute('aria-label', 'Next image');
    next.innerHTML = CHEVRON('9 18 15 12 9 6');

    overlay.appendChild(close);
    overlay.appendChild(prev);
    overlay.appendChild(next);
    overlay.appendChild(track);
    document.body.appendChild(overlay);

    function shut() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    // WH-254: upgrade a slide to its high-res zoom image the first time it's viewed (on open / navigate),
    // so the 1400w source is fetched on demand rather than at page load.
    function loadHiRes(i) {
      var big = bigs[i];
      if (big && big._zoomSrc && big.getAttribute('src') !== big._zoomSrc) {
        big.src = big._zoomSrc;
        big._zoomSrc = '';
      }
    }
    function go(dir) {
      var w = track.clientWidth || 1;
      var i = Math.round(track.scrollLeft / w) + dir;
      i = Math.max(0, Math.min(imgs.length - 1, i));
      loadHiRes(i);
      track.scrollTo({ left: i * w, behavior: 'smooth' });
    }
    close.addEventListener('click', shut);
    prev.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    next.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    /* tap the dimmed backdrop (not the image, arrows, or close) closes */
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('.phc-lightbox__nav') || e.target === close || e.target.tagName === 'IMG') return;
      shut();
    });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') shut();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    imgs.forEach(function (img, idx) {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', function () {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        loadHiRes(idx);
        // open at the tapped image; swipe left/right moves between the rest
        track.scrollLeft = idx * track.clientWidth;
      });
    });

    /* expand-hint icon over the gallery (signals tap-to-expand) */
    var car = document.querySelector('.phc-carousel');
    if (car && !document.querySelector('.phc-zoom-hint')) {
      var host = car.parentNode;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var hint = document.createElement('button');
      hint.type = 'button';
      hint.className = 'phc-zoom-hint';
      hint.setAttribute('aria-label', 'Expand image');
      hint.innerHTML = '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>';
      hint.addEventListener('click', function () {
        var w = car.clientWidth || 1, center = car.scrollLeft + w / 2, best = 0, bestD = Infinity;
        car.querySelectorAll('.phc-slide').forEach(function (s, i) {
          var d = Math.abs((s.offsetLeft + s.offsetWidth / 2) - center);
          if (d < bestD) { bestD = d; best = i; }
        });
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        track.scrollLeft = best * track.clientWidth;
      });
      host.appendChild(hint);
      // Position is fixed via CSS (.phc-zoom-hint bottom: -9px, same value as .phc-trusted-badge) —
      // no runtime measurement, no resize listener. Keeps the zoom hint and the "Bought by" trust
      // badge on the same line, 5px above the slider, with zero layout-shift cost after paint.
    }
  }
  if (document.readyState !== 'loading') initLightbox();
  else document.addEventListener('DOMContentLoaded', initLightbox);
})();
